<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb separator=">" class="breadcrumb_zdy">
        当前位置:
        <BreadcrumbItem :to="{name: 'OrgList'}">金融机构</BreadcrumbItem>
        <!-- <BreadcrumbItem><a href="javascript:history.back(-1)" >详情页</a></BreadcrumbItem> -->
        <BreadcrumbItem>{{detail.short_name}}</BreadcrumbItem>
      </Breadcrumb>
      <!-- <div>
        <a href="javascript:history.back(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
      </div> -->
    </div>
    <div class="detail_hearder">
      <div class="logo_img">
        <img :src="detail.logo_path | logo_show" />
      </div>
      <div class="detail_info">
        <div>
          <div>
            <div class="title">{{detail.short_name}}<span class="span_tag" v-if="detail.org_type_id">{{detail.org_type_id | deal('org_type')}}</span></div>
            <div class="dec">
              <span v-if="detail.address_id">{{detail.address_id | addressDeal('2')}}</span>
              <span v-if="detail.setup_time">{{detail.setup_time | timeTrans}}</span>
              <a :href="detail.main_page | page" target="_blank" v-if="detail.main_page">{{detail.main_page}}</a>
              <span v-if="!detail.setup_time && !detail.main_page && !detail.address_id">暂无描述</span>
            </div>
          </div>

          <div class="attention-dropdown" v-if="detail.id">
            <Button v-if="!filter.attentioned(detail.id, _ids_entity(1))" class="attentioned_yes_button attentioned_button" @click="haddleSubscribe">
              <div class="layout-between-center">
                <i class="attention-iconfont">&#xe64a;</i><span>添加关注</span>
              </div>
            </Button>
            <Button v-else class="attentioned_no_button attentioned_button" @click="haddleCancel">
              <div class="layout-between-center">
                <i class="attention-iconfont">&#xe64b;</i><span>已关注</span>
              </div>
            </Button>
          </div>
        </div>
        <ul class="data_list">
          <li v-if="num.comp_num">
            <p class="p1">{{num.comp_num}}</p>
            <p class="p2">已投公司数</p>
          </li>
          <li v-if="num.event_num">
            <p class="p1">{{num.event_num}}</p>
            <p class="p2">事件数</p>
          </li>
          <li v-if="num.next_rz_num">
            <p class="p1">{{num.next_rz_num}}</p>
            <p class="p2">进入下一轮</p>
          </li>
        </ul>
      </div>
    </div>
    <div ref="content"></div>
    <Layout class="detail_content" :style="{'min-height':height+'px'}">
      <Sider :class="{'fixed': sider_fixed}" :style="{'height': sider_height+'px'}" ref="sider" hide-trigger width="152">
        <Menu :active-name="active_name" @on-select="change" width="100%">
          <MenuItem name="base" onclick="_czc.push(['_trackEvent', '机构详情', '机构详情tab点击（机构资料）'])">
          <i class="iconfont icon">&#xe634;</i><span>机构资料</span>
          </MenuItem>
          <MenuItem :disabled="components_data.indexOf('ProjectInfo') == -1" name="project" onclick="_czc.push(['_trackEvent', '机构详情', '机构详情tab点击（对外投资）'])">
          <i class="iconfont icon">&#xe653;</i><span>对外投资</span>
          </MenuItem>
          <MenuItem :disabled="components_data.indexOf('TeamInfo') == -1" name="team" onclick="_czc.push(['_trackEvent', '机构详情', '机构详情tab点击（团队概况）'])">
          <i class="iconfont icon">&#xe64f;</i><span>团队概况</span>
          </MenuItem>
          <MenuItem :disabled="components_data.indexOf('NewsInfo') == -1" name="news" onclick="_czc.push(['_trackEvent', '机构详情', '机构详情tab点击（新闻报道）'])">
          <i class="iconfont icon">&#xe651;</i><span>新闻报道</span>
          </MenuItem>
          <MenuItem :disabled="components_data.indexOf('Win') == -1" name="win" onclick="_czc.push(['_trackEvent', '公司详情', '中标项目'])">
          <i class="iconfont">&#xe736;</i><span>中标项目</span>
          </MenuItem>
          <MenuItem :disabled="components_data.indexOf('Buy') == -1" name="buy" onclick="_czc.push(['_trackEvent', '公司详情', '采购项目'])">
          <i class="iconfont">&#xe74b;</i><span>采购项目</span>
          </MenuItem>
        </Menu>
      </Sider>
      <Content :class="{'fixed': sider_fixed}">
        <BaseInfo v-show="active_name == 'base'" key="base" @getname="getName" @gonews="change"></BaseInfo>
        <ProjectInfo @callbackData="callbackData" v-show="active_name == 'project'" key="project"></ProjectInfo>
        <TeamInfo @callbackData="callbackData" v-show="active_name == 'team'" key="team"></TeamInfo>
        <NewsInfo @callbackData="callbackData" v-show="active_name == 'news'" key="news"></NewsInfo>
        <Win @callbackData="callbackData" v-show="active_name == 'win'" key="win"></Win>
        <Buy @callbackData="callbackData" v-show="active_name == 'buy'" key="buy"></Buy>
      </Content>
    </Layout>
    <div class="content_footer" ref="content_footer"></div>
    <OrgModal ref="org_modal" :imgurl="org_modal_img">
      <p class="p1" slot>{{org_modal_p}}</p>
    </OrgModal>
  </div>
</template>

<script>
import { entityDetail } from '@/service'
import BaseInfo from './components/BaseInfo'
import TeamInfo from './components/TeamInfo'
import ProjectInfo from './components/ProjectInfo'
import NewsInfo from './components/NewsInfo'
import Win from './components/Win'
import Buy from './components/Buy'
import OrgModal from '@/components/OrgModal.vue'
import filter from 'js/filter'
import { atten_common } from 'js/atten_common'
export default {
  metaInfo() {
    return {
      title: this.meta_title
    }
  },
  inject: ['login'],
  mixins: [atten_common],
  components: {
    BaseInfo,
    TeamInfo,
    NewsInfo,
    ProjectInfo,
    Win,
    Buy,
    OrgModal,
  },
  data() {
    return {
      active_name: 'base',
      detail: '',

      params: {
        group_id: [],
      },
      attention_visible: false,
      button_loading: false,
      filter: filter,
      // loginModal: false,
      params_num: {
        uid: this.$route.params.uid,
        type: 'num',
        entity_type: 1,
      },
      num: '',
      height: 0,
      sider_fixed: false,
      sider_height: 528,

      meta_title: '动脉橙-数字健康产业信息服务商',
      components_data: []
    }
  },
  methods: {
    async getDetail() {
      // 统计
      let res3 = await entityDetail(this.params_num, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res3.status == 'success') {
        this.num = {
          comp_num: res3.comp_num,
          event_num: res3.event_num,
          next_rz_num: res3.next_rz_num,
        }
      } else {
        this.$Message.error(res3.msg)
      }
    },
    getName(detail) {
      this.$set(this.$data, 'detail', detail)
      this.meta_title = detail.short_name + '-动脉橙'
    },
    change(name) {
      this.active_name = name
    },
    haddleSubscribe() {
      if (this.$store.state.user_key) {
        this.addSubscribe(1, this.detail.id, this.subscribeSuccess)
      } else {
        this.login()
      }
    },
    haddleCancel() {
      if (this.$store.state.user_key) {
        let i = this.$store.state.attention.subscribe.findIndex(a => a.sub_type_id == this.detail.id)
        if(i > -1) {
          this.deleteSubscribe(this.$store.state.attention.subscribe[i]['id'], this.cancelSuccess)
        }
      } else {
        this.login()
      }
    },
    callbackData(value) {
      this.components_data.push(value)
    }
  },
  created() {
    this.getDetail()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 303
    // window.onresize = () => {
    //   this.height = document.documentElement.clientHeight - 342
    // }
    if ('active_name' in this.$route.query) {
      this.active_name = this.$route.query.active_name
    }
    this.$nextTick(() => {
      this.sider_height = this.$refs['sider'].$el.scrollHeight
      window.onscroll = () => {
        if (this.$refs['content'].getBoundingClientRect().top < 64 - 16) {
          this.sider_fixed = true
        } else {
          this.sider_fixed = false
        }
        if (this.$refs['content_footer'].getBoundingClientRect().top < this.sider_height + 64) {
          this.sider_height = this.$refs['content_footer'].getBoundingClientRect().top - 64
        } else {
          this.sider_height = this.$refs['sider'].$el.scrollHeight
        }
      }
    })
  },
  destroyed() {
    window.onscroll = ''
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.index_content
  padding 16px 0 0
  .detail_hearder
    propsition relative
    margin-top 16px
    commonBgColor(#1f2330, #FFFFFF)
    display flex
    line-height 1
    .logo_img
      flex 0 0 154px
      height 154px
      line-height 152px
      commonBorderColor(#FFFFFF, #E8E8E8)
    .detail_info
      flex auto
      >div:nth-child(1)
        display flex
        align-items center
        justify-content space-between
        min-height 88px
      .attention-dropdown
        margin-right 32px
      .title
        commonColor(#E9E9EB, #333333)
        font-size 24px
        padding 20px 30px 0
        span
          margin-left 10px
      .dec
        padding 15px 30px
        min-height 44px
        a
          color #188DED
          text-decoration underline
        span
          display inline-table
          font-size 14px
          color #797B83
          padding-right 15px
          margin-right 14px
          position relative
          &:before
            content ''
            position absolute
            width 1px
            height 14px
            commonBgColor(#40444f, #D9D9D9)
            top 0
            right 0
          &:last-child
            padding-right 0
            margin-right 0
            &:before
              content none
      .data_list
        display flex
        commonBgColor(#2A2F42, #F9F9F9)
        height 56px
        margin-top 10px
        li
          padding-right 1px
          text-align center
          flex 0 0 130px
          position relative
          .p1
            font-size 20px
            commonColor(#e9e9eb, #666666)
            margin-top 10px
          .p2
            font-size 12px
            commonColor(#797B83, #999999)
            margin-top 4px
          &:before
            content ''
            position absolute
            width 1px
            height 36px
            top 10px
            right 0
            commonBgColor(#40444f, #E9E9E9)
          &:last-child:before
            content none
  .detail_content
    margin-top 16px
    // margin-bottom: 30px
    commonBgColor(#1f2330, #FFFFFF)
    .ivu-layout-sider
      overflow auto
      &.fixed
        position fixed
        top 64px
        left calc(((100% - 1200px) / 2))
    & >>> .ivu-menu-light
      background transparent
      .ivu-menu-item  
        font-size 14px
        color #ff8824
        cursor pointer
        &:hover
          background: #fffaf5
        &.ivu-menu-item-disabled
          color #999 !important
        background: #fff
      &:after
        content none
      .ivu-menu-item-active:not(.ivu-menu-submenu)
        commonBgColor(rgba(255, 255, 255, 0.05), #fffaf5)
        color rgba(250, 122, 80, 1)
        span
          font-weight 800
        &:after
          content none
    .ivu-layout-content
      border-left 1px solid
      commonBorderColor(#40444F, #E9E9E9)
      overflow auto
      position relative
      &.fixed
        margin-left 152px
      &::-webkit-scrollbar-track
        border 0
        commonBgColor(#1F2330, #FFFFFF)
      &::-webkit-scrollbar
        width 4px
        commonBgColor(#1F2330, #FFFFFF)
      &::-webkit-scrollbar-thumb
        border-radius 4px
        commonBgColor(#4c4f59, #e8e8e8)
.content_footer
  height 30px
  commonBgColor(#181a23, #f5f7f9)
  position relative
  z-index 100
  width 100%
</style>
